export const LANDING_ROUTE = '/';
export const SIGNIN_ROUTE = '/login';
export const SIGNUP_ROUTE = '/join';
export const HOME_ROUTE = '/home';
export const DASHBOARD = '/dashboard';
export const PROFILES = '/profiles';
export const SINGLEPROFILE = '/profile/:userId';
export const EDITPROFILE = '/edit-profile/';
export const ALLQA_ROUTE = '/allqa';
export const ASK_ROUTE = '/ask';
export const SINGLEQUES_ROUTE = '/question/:quesId';
export const EDITQUES_ROUTE = '/edit-question/:quesId';
export const POST_BLOG = '/post-blog';
export const GET_BLOG = '/blogs/:blogId';
